module.exports = __webpack_public_path__ + "img/calendar-empty-state.132664eb.svg";